import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'

import { checkIsGlanceView, injectScript } from '@shared/utils'

const Ads = dynamic(() => import('@shared/components/ads'))
const GlanceAd = dynamic(() => import('@shared/components/ads/glanceAd'))
const LiveArticle = dynamic(() => import('@shared/components/articleDetail/liveArticle'))
const MultiPoll = dynamic(() => import('@shared/components/multiPoll'))
const MultiQuiz = dynamic(() => import('@shared/components/multiQuiz'))
const ReelsHomePage = dynamic(() => import('@shared/components/reelsHomePage'))
const ArticleAlsoRead = dynamic(() => import('@shared/components/articleDetail/articleAlsoRead'))

function ArrayHtml({ data, customAds = {}, article }) {
  let pTagCount = 0
  const router = useRouter()
  const isGlanceView = checkIsGlanceView(router?.query)
  const checkContent = useRef({})
  const editorAds = {
    1: {
      id: 'gt-ads-1',
      adIdDesktop: 'Crictracker_New_Desktop_AP_MID_728x90',
      adIdMobile: 'Crictracker_New_Mobile_AP_MID1_300x250',
      dimensionDesktop: [728, 90],
      dimensionMobile: [300, 250],
      mobile: true,
      slotId: '23148549803',
      className: 'text-center mb-2 mb-md-3'
    },
    2: {
      id: 'div-ad-gpt-138639789-1660131756-1',
      adIdDesktop: 'Crictracker_New_Desktop_AP_MID_728x90',
      adIdMobile: 'Crictracker_New_Mobile_AP_MID1_300x250',
      dimensionDesktop: [728, 90],
      dimensionMobile: [300, 250],
      mobile: true,
      slotId: '23148549803',
      className: 'text-center mb-2 mb-md-3'
    }
  }

  function getAdCode(key) {
    return {
      adCode: customAds[key],
      Components: isGlanceView ? GlanceAd : Ads
    }
  }

  useEffect(() => {
    if (checkContent.current?.x && window?.twttr) {
      window?.twttr?.widgets?.load()
    } else if (checkContent.current?.x) {
      injectScript('https://platform.twitter.com/widgets.js').then(() => {
        window?.twttr?.widgets?.load()
      })
    }
    if (checkContent.current?.i && window?.instgrm) {
      window?.instgrm?.Embeds?.process()
    } else if (checkContent.current?.i) {
      injectScript('https://www.instagram.com/embed.js').then(() => {
        window?.instgrm?.Embeds?.process()
      })
    }
  }, [])

  if (data?.length) {
    return data?.map((e, i) => {
      checkContent.current[e?.eType] = e?.oProps
      if (e?.eType === 'q' && e?.oProps?.id) {
        // Quiz
        return <MultiQuiz key={`${e?.eType}-${i}`} id={e?.oProps?.id} className={'mb-3'} />
      } else if (e?.eType === 'r') {
        // reel
        return <ReelsHomePage key={`${e?.type}-${i}`} isArticle />
      } else if (e?.eType === 'p' && e?.oProps?.id) {
        // Poll
        return <MultiPoll key={`${e?.eType}-${i}`} id={e?.oProps?.id} className={'mb-3'} />
      } else if (!isGlanceView && e?.eType === 'a' && editorAds[e?.oProps?.['data-key']]) {
        // Editor Ads
        return <Ads key={`${e?.eType}-${i}`} {...editorAds[e?.oProps?.['data-key']]} />
      } else if (e?.eType === 'ara') {
        return <ArticleAlsoRead key={`${e?.eType}-${i}`} data={e} article={article?.aAlsoReadArticles} fantasyArticle={article?.aAlsoReadFArticles} />
      } else if (e?.eType === 'la' && article?.iEventId) {
        // Live Blog
        return (
          <React.Fragment key={`${e?.eType}-${i}`}>
            <h4>Follow all the live action here!</h4>
            <LiveArticle
              liveArticleList={article?.oLiveArticleList}
              liveArticleEvent={article?.oLiveArticleEvent}
              liveEventId={article?.iEventId}
            />
          </React.Fragment>
        )
      } else if (e?.eType === 'h') {
        // HTML content
        const nextEle = data?.[i + 1]
        const Tag = e?.sTagName?.toLowerCase() || 'p'
        if (Tag === 'hr' || Tag === 'br' || Tag === 'img') {
          return <Tag key={`${e?.eType}-${i}`} {...e?.oProps} />
        } else if (Tag === 'p') {
          const { adCode, Components } = getAdCode(pTagCount)
          pTagCount += 1
          return (
            <React.Fragment key={`${e?.eType}-${i}`}>
              <Tag {...e?.oProps} dangerouslySetInnerHTML={{ __html: e?.sContent || '' }} />
              {adCode?.id && nextEle?.sTagName && <Components {...adCode} />}
            </React.Fragment>
          )
        } else {
          return <Tag key={`${e?.eType}-${i}`} {...e?.oProps} dangerouslySetInnerHTML={{ __html: e?.sContent || '' }} />
        }
      } else if (e?.eType && e?.sTagName) {
        const Tag = e?.sTagName?.toLowerCase() || 'p'
        return <Tag key={`${e?.eType}-${i}`} {...e?.oProps} dangerouslySetInnerHTML={{ __html: e?.sContent || '' }} />
      } else return null
    })
  } else return null
}
ArrayHtml.propTypes = {
  data: PropTypes.array,
  customAds: PropTypes.object,
  article: PropTypes.object
}
export default React.memo(ArrayHtml)
